import React from "react";
import { Link, useLocation } from "react-router-dom";

const OrderSucessfullPlaced = () => {
  const location = useLocation();
  const Orderdata = new URLSearchParams(location.search).get("orderid");
  const totalamt = new URLSearchParams(location.search).get("totalamt");
  if (!Orderdata && !totalamt) {
    window.location.href = "/";
  }
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ height: "50vh" }}
    >
      <h2>Your Order has been Successfully Placed!</h2>
      <p>Your order id is {Orderdata}.</p>
      <p>Total Amount : {totalamt} </p>
      <p>You can make Payment for Order if you want or click Home </p>
      <div style={{ display: "flex", gap: 6, padding: 7 }}>
        <Link to={`/payments/paypal/process/${Orderdata}`} className="mb-3">
          <button className="btn btn-primary rounded">Pay</button>
        </Link>
        <Link to="/">
          <button className="btn btn-primary rounded">Home</button>
        </Link>
      </div>
    </div>
  );
};

export default OrderSucessfullPlaced;
